import {
  AfterContentInit,
  Component,
  ComponentFactoryResolver, ComponentRef,
  Injector,
  OnDestroy,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

@Component({
  standalone: false,
  template: '<div #target></div>'
})
export class DynamicModalComponent implements OnDestroy, AfterContentInit {
  /**It is important to set static to true, because target query should be init when DynamicModalComponent OnInit called*/
  @ViewChild('target', { read: ViewContainerRef, static: true }) target: ViewContainerRef;

  // embedded data
  public component: Type<Component>;
  public componentResolver: ComponentFactoryResolver;
  public data: any;

  private _componentRef: ComponentRef<any>;

  constructor(private _injector: Injector) {
  }

  ngAfterContentInit(): void {
    this._clearComponent();

    if (this.component) {
      const childComponent = this.componentResolver.resolveComponentFactory(this.component);

      const refInjector = Injector.create({
        providers: [{
          provide: this.component,
          useValue: this.component
        }],
        parent: Injector.create({ providers: [], parent: this._injector })
      });

      this._componentRef = this.target.createComponent(childComponent, 0, refInjector);
      Object.assign(this._componentRef.instance, this.data);
    }
  }

  public ngOnDestroy() {
    this._clearComponent();
  }

  private _clearComponent() {
    if (this.target) {
      this.target.clear();
    }

    if (this._componentRef) {
      this._componentRef.destroy();
    }
  }
}
